import React, { forwardRef } from "react";
import Tooltip from '@mui/material/Tooltip';

export const SubTypeTooltipRenderer = forwardRef(({ 
  value, 
  data,
  colDef 
}, ref) => {
  
  const getTooltipContent = () => {
    // Use the same logic as tooltipValueGetter but for rendering
    const reasonCodes = data?.reasonCodes;
    if (reasonCodes && reasonCodes.length > 0) {
      const codes = reasonCodes.map(rc => rc.reasonCode).filter(Boolean);
      if (codes.length > 1) {
        return (
          <div>
            {codes.map((code, index) => (
              <div key={index} style={{ margin: '2px 0' }}>{code}</div>
            ))}
          </div>
        );
      }
      return codes[0] || value;
    }
    
    const docs = data?.requestFeedDocumentDTOList;
    if (docs && docs.length > 0) {
      const uniqueSubTypes = [...new Set(docs.map(d => d.requestSubTypeName).filter(Boolean))];
      if (uniqueSubTypes.length > 1) {
        return (
          <div>
            {uniqueSubTypes.map((subType, index) => (
              <div key={index} style={{ margin: '2px 0' }}>{subType}</div>
            ))}
          </div>
        );
      }
      return uniqueSubTypes[0] || value;
    }
    
    return data?.requestSubTypeName || value;
  };

  const tooltipContent = getTooltipContent();
  const shouldShowTooltip = 
    (data?.reasonCodes && data.reasonCodes.length > 1) ||
    (data?.requestFeedDocumentDTOList && data.requestFeedDocumentDTOList.length > 1) ||
    (value && value.length > 30); // Show tooltip for long single values

  return (
    <div ref={ref} style={{ 
      overflow: "hidden", 
      textOverflow: "ellipsis", 
      whiteSpace: "nowrap",
      width: "100%"
    }}>
      {shouldShowTooltip ? (
        <Tooltip 
          title={tooltipContent} 
          placement="bottom-start"
          arrow
          enterDelay={300}
          leaveDelay={0}
        >
          <span style={{ cursor: 'help' }}>{value}</span>
        </Tooltip>
      ) : (
        <span>{value}</span>
      )}
    </div>
  );
});

SubTypeTooltipRenderer.displayName = 'SubTypeTooltipRenderer';